import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7573e122"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid grid-header-title w-full -ml-2 -mr-2" }
const _hoisted_2 = { class: "col-6" }
const _hoisted_3 = { class: "mt-2 mr-2 ml-0 mb-0 font-normal" }
const _hoisted_4 = { class: "col-4 col-offset-2 flex justify-content-end align-items-center" }

import { withDefaults, computed } from "vue";

/**
 * PrimeVue UIコンポーネント
 * - Button: ボタンコンポーネント（複製、キャンセル用）
 */
import Button from "primevue/button";

/**
 * 複製ヘッダーサイドバーのプロパティ型定義
 */
type IHeaderDuplicateSidebar = {
  /** 予約ID */
  bookingId: string | undefined;
  /** 自由予約フラグ */
  is_free_space?: boolean;
};

/**
 * コンポーネントのプロパティ定義
 * デフォルト値を設定
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'header',
  props: {
    bookingId: { default: "" },
    is_free_space: { type: Boolean }
  },
  emits: ["duplicate", "cancel"],
  setup(__props: any, { emit: emits }) {

const props = __props as { bookingId: string | undefined, is_free_space?: boolean };

/**
 * Vue 3 Composition APIの基本機能
 * - withDefaults: プロパティのデフォルト値を設定
 * - defineProps: コンポーネントのプロパティを定義
 * - defineEmits: コンポーネントから親へのイベント発行を定義
 * - computed: 計算されたプロパティを作成
 */


/**
 * 自由予約かどうかを判定する
 * @returns {boolean} 自由予約の場合はtrue
 */
const isFreeSpace = computed(() => {
  return !!props.is_free_space;
});

/**
 * コンポーネントから親コンポーネントへのイベント発行
 */


/**
 * 複製ボタンクリック時の処理
 */
const onDuplicate = () => {
  emits("duplicate");
};

/**
 * キャンセルボタンクリック時の処理
 */
const onCancel = () => {
  emits("cancel");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(isFreeSpace) ? "自由予約複製" : "予約複製"), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_unref(Button), {
        label: "キャンセル",
        class: "btn-white mr-3",
        size: "small",
        onClick: onCancel
      }),
      _createVNode(_unref(Button), {
        label: "複製を保存",
        class: "btn-orange",
        size: "small",
        onClick: onDuplicate
      })
    ])
  ]))
}
}

})